<template>
  <section class="page" v-loading="!ready" element-loading-text="Chargement initial en cours...">
    <header-page :statusFilters="showFilters" @clickFilters="clickFilters" />
    <section class="main" v-if="ready" :data-ready="ready">
      <filters :statusFilters="showFilters" :games="games" @changeStatus="changeStatus" @changeFilters="changeFilters"/>
      <main-content :games="games" :statuses="statusesSelected" :filters="filtersSelected"/>
    </section>
  </section>
</template>

<script>
import Filters from '@/components/sport/games/Filters'
import HeaderPage from '@/components/sport/games/Header'
import MainContent from '@/components/sport/games/Main'
export default {
  name: 'SportGames',
  components: { Filters, HeaderPage, MainContent },
  data: function () {
    return {
      showFilters: true,
      statuses: [],
      filters: []
    }
  },
  computed: {
    games () { return this.$store.getters['Sport/Game/list'] },
    ready () {
      return this.$store.getters['Main/Area/list']?.length > 0 &&
        this.$store.getters['Sport/Season/list']?.length > 0 &&
        this.$store.getters['Sport/Competition/list']?.length > 0
      // return true
    },
    statusesSelected () { return this.statuses },
    filtersSelected () { return this.filters }
  },
  created () {
    this.$store.iDebug = 'iDebug' in this.$route.query

    document.title = 'Games - Multisport - iDalgoAdmin'
    this.$store.commit('Server/page', this.$route.path)

    this.$store.dispatch('Main/Area/set')
    this.$store.dispatch('Sport/Season/init')
    this.$store.dispatch('Sport/Competition/init')
  },
  mounted () {
    this.$store.dispatch('Sport/RoundType/init')
    this.$store.dispatch('Sport/GroupType/init')
    this.$store.dispatch('Sport/Sport/init')
    this.$store.dispatch('Sport/Discipline/init')
    this.$store.dispatch('Sport/Classification/init')
    this.$store.dispatch('Sport/Gender/init')
    this.$store.dispatch('Sport/Event/init')
    this.$store.dispatch('Sport/EventUnit/init')
    this.$store.dispatch('Sport/GameStatus/init')
    this.$store.dispatch('Sport/GameStatusDiscipline/init')
    this.$store.dispatch('Sport/ScoreDiscipline/init')
  },
  methods: {
    clickFilters () { this.showFilters = !this.showFilters },
    changeStatus (statuses) { this.statuses = statuses },
    changeFilters (filters) { this.filters = filters }
  }
}
</script>

<style>
  :root{
    --color-background-bg:black;
    --color-background:white;
    --color-primary-bg:#3f51b5;
    --color-primary:white;
    --color-disable-bg:#999;
    --color-disable:white;
    --color-over:#dce9f7;
    --color-text-placeholder:#333;

    --color-upcoming:#3f51b5;
    --color-live:green;
    --color-stopped:#b67600;
    --color-ended:red;

    --font:verdana
  }
  body{
    background-color:var(--color-background-bg);
    font-family:var(--font)
  }
  select,
  /* optgroup, */
  option{
    font-family:var(--font)
  }
  select:focus-visible{
    outline:none
  }
  select{
    border-radius:4px;
    background-color:var(--color-primary);
    border:1px solid var(--color-primary-bg)
  }
  .page{
    display:flex;
    flex-direction:column
  }
  .main{
    display:flex;
    flex:1 1 auto;
    z-index:0
  }
</style>
